import React, {} from 'react'
import Expandable, {ExpandableProps} from './Expandable'
import './Toast.css';
import {
  SuccessIcon,
  FailureIcon,
  WarningIcon,
  CloseIcon,
} from '../../components/Icons/Icons'

export type ToastProps = {
    message: string
    type: Types
    onClose: any
}
export type Types = "warning" | "success" | "failure";
export type ToastData = {
    id: number,
    type: Types
    message: string
}
function Toast(props:ToastProps){
    const { message, type, onClose } = props 
    const iconMap = {
        success: <SuccessIcon />,
        failure: <FailureIcon />,
        warning: <WarningIcon />,
    }
    const toastIcon = iconMap[type] || null
    console.log("Rendering Toast with message:", message, "and type:", type)
    const base = 100
    const msgValue = parseInt(message.trim().split(":").pop())
    const rpm3 = base - msgValue + 3
    const rpm6 = base - msgValue + 9
    const density = 1 + (msgValue / base)

    return(    
    <div className={`toastie toastie--${type}`} role="alert">
        <div className="toastie-message">
            {toastIcon &&(
                <div className="icon icon--lg icon--thumb">{toastIcon}</div>
            )}
                <Expandable isOpen={false} title="Low Shear Rate Increase">
                    <p className="toastie-text highlight">Trend Values</p>
                    <ol>
                        <li className="toastie-text">{`RPM3: ${rpm3}`}</li>
                        <li className="toastie-text">{`RPM6: ${rpm6}`}</li>
                        <li className="toastie-text">{`Density: ${density}`}</li>
                    </ol>
                    <p className="toastie-text highlight">Potential Causes:</p>
                    <ul>
                        <li className="toastie-text">"Increase of low gravity solids concentration"</li>
                        <li className="toastie-text">"Gradual size reduction of particles in fluids"</li>
                        <li className="toastie-text">"Poor hole cleaning with cuttings remaining in the well for escessive periods of time"</li>
                        <li className="toastie-text">"Increasing water content in the fluid"</li>
                        <li className="toastie-text">"Need for decant in centrifuge processing"</li>
                    </ul>
                </Expandable>
        </div>
        <button className="toastie-close-btn" onClick={onClose}>
            <span className="icon"><CloseIcon /></span>
        </button>
    </div>
    )
}
export default Toast